import React, { useEffect, useState, useRef, useMemo } from 'react'
import axios from 'axios'
import '../../../styles/FormActualite.css'
import MenuAdmin from './MenuAdmin'
import JoditEditor from 'jodit-react'

const FormActualite = ({ placeholder }) => {
  const editor = useRef(null)
  const listemois = [
    'janvier',
    'fevrier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'aout',
    'août',
    'septembre',
    'octobre',
    'novembre',
    'decembre',
    'décembre',
  ]
  const [jour, setJour] = useState('')
  const [mois, setMois] = useState('')
  const [lien, setLien] = useState('')
  const [libelle, setLibelle] = useState('')
  const [donneesJson, setDonneesJson] = useState({})
  const form = document.getElementsByTagName('form')

  useEffect(() => {
    lireJsonFile()
  }, [])

  useEffect(() => {
    if (donneesJson.length > 0) {
      majVisu()
      setLibelle(donneesJson[0]['annonce'])
    }
  }, [donneesJson])

  const handleChange = (e) => {
    e.preventDefault()

    if (
      e.target.name === 'mois' &&
      !listemois.includes(e.target.value.toLowerCase())
    ) {
      e.target.value = null
      e.target.className = 'inputInvalid'
    }
    majVisu()
  }

  const handleChangeLibelle = (value) => {
    setLibelle(value)
  }

  const majVisu = () => {
    if (form.length === 1) {
      const donneesFormulaire = new FormData(form[0])
      setJour(donneesFormulaire.get('jour'))
      setMois(donneesFormulaire.get('mois'))
      setLien(donneesFormulaire.get('lien'))
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (form.length === 1) {
      if (libelle !== '' && libelle !== null) {
        const objetJSON = {
          id: 1,
          jour: jour,
          mois: mois,
          lien: lien,
          annonce: libelle,
        }
        modifyData(e.nativeEvent.submitter.id, objetJSON)
      }
    }
  }

  function lireJsonFile() {
    axios
      .get('./json/itemsactualite.json')
      .then(function (response) {
        setDonneesJson(response.data)
      })
      .catch(function (error) {
        console.error('Erreur lors de la mise à jour des données JSON', error)
      })
  }

  const modifyData = (selModif, objetJSON) => {
    if (donneesJson) {
      if (selModif === 'btenregistrerActualite') {
        donneesJson.splice(4, 1)
        donneesJson.map((donnees) => (donnees.id = donnees.id + 1))
        donneesJson.splice(0, 0, objetJSON)
      } else {
        donneesJson[0] = objetJSON
      }
      setDonneesJson(donneesJson)
      saveJsonFile(donneesJson)
    }
  }

  const saveJsonFile = async (donneesAEnregistrer) => {
    const nomFichier = 'itemsactualite.json'
    const cheminFichier = '../json'
    if (donneesAEnregistrer) {
      try {
        // Convertir les données en chaîne JSON
        const donneesJson = JSON.stringify(donneesAEnregistrer, null, 2)

        const response = await axios.post(
          // Appel vers le serveur PHP local (Développement)
          // 'http://localhost:8000/enregistrejson_v2.php',
          // Appel vers le serveur (Production)
          './php/enregistrejson_v2.php',
          {
            nomFichier,
            cheminFichier,
            donneesJson,
          }
        )
        if (response.status === 200) {
          alert("L'actualité a bien été enregistrée.")
        } else {
          alert("L'actualité n'a pas été enregistrée.")
        }
      } catch (error) {
        console.error(error)
      }
    }
  }

  const buttons = [
    'undo',
    'redo',
    '|',
    'bold',
    'strikethrough',
    'underline',
    'italic',
    '|',
    'superscript',
    'subscript',
    '|',
    'align',
    '|',
    'ul',
    'ol',
    'outdent',
    'indent',
    '|',
    'font',
    'fontsize',
    'brush',
    'paragraph',
    '|',
    'link',
    '|',
    'hr',
    'selectall',
    '|',
    'source',
  ]

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: placeholder || '',
      toolbar: true,
      spellcheck: true,
      language: 'fr',
      toolbarButtonSize: 'medium',
      toolbarAdaptive: false,
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: true,
      askBeforePasteFromWord: true,
      buttons: buttons,
    }),
    [placeholder]
  )

  return (
    <div id="formActualite" className="formActualite">
      <MenuAdmin />
      <form onSubmit={handleSubmit} className="enveloppe">
        <p className="enveloppeTitle">
          <span className="enveloppeUnderline">Actualités:</span>
        </p>

        {/* Ligne pour Jour et Mois */}
        <div className="inputRow">
          <div className="inputGroupHalf">
            <label className="label" htmlFor="jour">
              Jour
            </label>
            <input
              name="jour"
              type="text"
              id="jour"
              className="inputField"
              defaultValue={donneesJson[0] ? donneesJson[0].jour : ''}
              required
              onBlur={handleChange}
            />
          </div>

          <div className="inputGroupHalf">
            <label className="label" htmlFor="mois">
              Mois
            </label>
            <input
              name="mois"
              type="text"
              id="mois"
              className="inputField"
              defaultValue={donneesJson[0] ? donneesJson[0].mois : ''}
              required
              onBlur={handleChange}
            />
          </div>
        </div>

        {/* Ligne pour Lien (centré) */}
        <div className="lienGroup">
          <label className="label" htmlFor="lien">
            Lien
          </label>
          <input
            name="lien"
            type="text"
            id="lien"
            className="inputField"
            style={{ maxWidth: '400px' }}
            defaultValue={donneesJson[0] ? donneesJson[0].lien : ''}
            required
            onBlur={handleChange}
          />
        </div>

        <div className="joditEditor">
          <JoditEditor
            ref={editor}
            value={libelle}
            config={config}
            tabIndex={1}
            onChange={handleChangeLibelle}
          />
        </div>

        <div className="validationContainer">
          <button
            type="submit"
            id="btenregistrerActualite"
            className="validationButton"
          >
            Enregistrer
          </button>
          <button
            type="submit"
            id="btmodifierActualite"
            className="validationButton"
          >
            Modifier
          </button>
        </div>

        <p className="aideText">
          Cette annonce représente la première annonce du groupe de 5, la
          dernière postée.
          <br />
          Appuyez sur le bouton "Modifier" pour modifier cette annonce sans rien
          changer d'autre.
          <br />
          Appuyez sur le bouton "Enregistrer" pour positionner l'annonce en haut
          et décaler les 5 autres vers le bas en éliminant la dernière.
        </p>
      </form>

      <div id="visutextehtml" className="visuTexteHtml">
        <div className="cellInfo">
          <div className="cellDate">
            <p className="jour">{jour}</p>
            <p className="mois">{mois}</p>
          </div>
          <div className="cellInfoDate">
            <p dangerouslySetInnerHTML={{ __html: libelle }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormActualite
